<template>
  <div class="activityDetail">
    <div class="partPage">
      <h4 class="title">收支情况</h4>
      <div class="container">
        <div class="netIncome">
          <div class="grayColor netTitle">净收入</div>
          <div class="netNum">
            {{ (incomeData.income - incomeData.expenses).toFixed(2) }}
          </div>
        </div>
        <div class="incomeWrap dis_flex">
          <div class="income">
            <div class="income" @click="getJumpUrl('incomeDetail')">
              <div class="grayColor netTitle">收入</div>
              <div class="num">{{ incomeData.income }}</div>
              <span class="arrowRight">
                <van-icon name="arrow" />
              </span>
            </div>
          </div>
          <div class="rateWrap">
            <div class="rate"></div>
          </div>
        </div>
        <div class="incomeWrap dis_flex">
          <div class="income">
            <div class="income" @click="getJumpUrl('expendDetail')">
              <div class="grayColor netTitle">支出</div>
              <div class="num">{{ incomeData.expenses }}</div>
              <span class="arrowRight">
                <van-icon name="arrow" />
              </span>
            </div>
          </div>
          <div class="rateWrap">
            <div class="rate"></div>
          </div>
        </div>
        <!-- jiekuan  -->
        <p class="netTitle" >借款</p>
        <div class="incomeWrap dis_flex">
          <div class="income">
            <div class="income" @click="getJumpDetail('borrowJkPage', 'zc')">
              <div class="grayColor smallTitle">累计办理金额</div>
              <div class="num">
                {{
                  projectBorrow.transactAmountTotal
                    ? projectBorrow.transactAmountTotal
                    : "0"
                }}
              </div>
              <span class="arrowRight">
                <van-icon name="arrow" />
              </span>
            </div>
          </div>
          <div class="rateWrap">
            <div class="rate"></div>
          </div>
        </div>
        <div class="incomeWrap dis_flex">
          <div class="income">
            <div class="income" @click="getJumpDetail('borrowJkPage', 'hk')">
              <div class="grayColor smallTitle">累计回款金额</div>
              <div class="num">
                {{
                  projectBorrow.returnAmountTotal
                    ? projectBorrow.returnAmountTotal
                    : "0"
                }}
              </div>
              <span class="arrowRight">
                <van-icon name="arrow" />
              </span>
            </div>
          </div>
          <div class="rateWrap">
            <div class="rate"></div>
          </div>
        </div>
        <!-- baozhengjin -->
        <p class="netTitle">保证金</p>
        <div class="incomeWrap dis_flex">
          <div class="income">
            <div class="income" @click="getJumpDetail('marginBzjPage', 'zc')">
              <div class="grayColor smallTitle">累计办理金额</div>
              <div class="num">
                {{
                  projectMargin.transactAmountTotal
                    ? projectMargin.transactAmountTotal
                    : "0"
                }}
              </div>
              <span class="arrowRight">
                <van-icon name="arrow" />
              </span>
            </div>
          </div>
          <div class="rateWrap">
            <div class="rate"></div>
          </div>
        </div>
        <div class="incomeWrap dis_flex">
          <div class="income">
            <div class="income" @click="getJumpDetail('marginBzjPage', 'hk')">
              <div class="grayColor smallTitle">累计回款金额</div>
              <div class="num">
                {{
                  projectMargin.returnAmountTotal
                    ? projectMargin.returnAmountTotal
                    : "0"
                }}
              </div>
              <span class="arrowRight">
                <van-icon name="arrow" />
              </span>
            </div>
          </div>
          <div class="rateWrap">
            <div class="rate"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="partPage">
      <h4 class="title">收支数据</h4>
      <div class="container">
        <ve-histogram
          :data="barData"
          :settings="chartBarSettings"
          :extend="chartBarExtendRound"
          :legend="barLegend"
        ></ve-histogram>
      </div>
    </div>
    <div class="partPage">
      <h4 class="title">收支数据趋势图</h4>
      <div class="container">
        <ve-line
          :data="barData"
          :settings="chartBarSettings"
          :legend="lineLegend"
        ></ve-line>
      </div>
    </div>
  </div>
</template>
<script>
// 图表
/* eslint-disable */
import Vue from "vue";
import VCharts from "v-charts";
Vue.use(VCharts);
import VeHistogram from "v-charts/lib/histogram.common";
import VeLine from "v-charts/lib/line.common";
import { mapMutations } from "vuex";
import { getDataArray } from "@/utils/common";
import { getDeviceType, closePage } from "@/common/getDeviceType/getDeviceType";
import newApi from "lodash";
export default {
  name: "budgetInfo",
  data() {
    return {
      chartBarSettings: {
        labelMap: {
          incomeAmount: "收入",
          expensesAmount: "支出",
        },
        dimension: ["createDate"],
      },
      barLegend: [
        {
          left: 0,
          top: 0,
          itemWidth: 10,
          itemHeight: 10,
        },
      ],
      lineLegend: [
        {
          left: 0,
          top: 0,
          itemWidth: 12,
          itemHeight: 2,
        },
      ],
      chartBarExtendRound: {
        series: {
          barWidth: 20,
        },
      },
      barData: {
        columns: ["createDate", "incomeAmount", "expensesAmount"],
        rows: [],
      },
      incomeData: {
        expenses: "", //支出金额
        income: "", //收入金额
      },
      projectBorrow: {
        transactAmountTotal: "", //借款支出金额
        returnAmountTotal: "", //借款收入金额
      },
      projectMargin: {
        transactAmountTotal: "", //保证金支出金额
        returnAmountTotal: "", //保证金收入金额
      },
      dataParams: {
        //图表数据
        projectId: "",
      },
      commonId: "",
      orgId: "",

      clientType: getDeviceType(), //手机类型
    };
  },
  mounted() {
    this.orgId = this.$route.query.orgId; //机构Id
    this.commonId = this.$route.query.commonId; //申请Id
    window.editPage = this.editPage; //编辑页面
    this.initPage();
    this.initBrrowMsg(); //借款，保证金支出收入金额
    let timeObj = getDataArray(12);

    this.dataParams.projectId = this.commonId;
    this.incomeChart();
  },
  methods: {
    ...mapMutations(["setShowLoad"]),

    initPage() {
      //收支统计
      let _this = this;
      _this.$api.project
        .incomeAndExpenses({ dateUnitType: "all", projectId: _this.commonId })
        .then((res) => {
          _this.setShowLoad(false);
          if (res.code == "1") {
            _this.incomeData = newApi.assign({}, _this.incomeData, res.data);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    initBrrowMsg() {
      let _this = this;
      _this.$api.project
        .projectBorrowAndMargin({ projectId: _this.commonId })
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.projectBorrow = newApi.assign(
              {},
              _this.projectBorrow,
              res.data.projectBorrow
            );
            _this.projectMargin = newApi.assign(
              {},
              _this.projectMargin,
              res.data.projectMargin
            );
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    incomeChart() {
      let _this = this;
      _this.$api.project
        .incomeAndExpensesChart(this.dataParams)
        .then((res) => {
          _this.setShowLoad(false);
          if (res.code == "1") {
            _this.$set(_this.barData, "rows", res.data);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    getJumpUrl(name) {
      let Url = window.location.protocol + "//" + window.location.host + "";
      let timestamp = Date.parse(new Date());
      let token = this.$route.query.token;
      Url =
        Url +
        "/OA-pageH5/#/" +
        name +
        "?token=" +
        token +
        "&commonId=" +
        this.commonId +
        "&orgId=" +
        this.orgId;
      if (this.clientType == "android") {
        window.android.getInfo(112, Url);
      } else {
        //IOS

        window.webkit.messageHandlers.getJumpUrl.postMessage(Url);
      }
      // }
    },
    getJumpDetail(routerUrl, type) {
      let Url = window.location.protocol + "//" + window.location.host + "";
      let timestamp = Date.parse(new Date());
      let token = this.$route.query.token;
      Url =
        Url +
        "/OA-pageH5/#/" +
        routerUrl +
        "?token=" +
        token +
        "&commonId=" +
        this.commonId +
        "&orgId=" +
        this.orgId +
        "&pageType=" +
        type;
      // window.location.href=Url;
      // if (this.clientType == "android") {
      //   window.android.getInfo(112, Url);
      // } else {
      //   //IOS
      //   console.log(Url);
      //   window.webkit.messageHandlers.getJumpUrl.postMessage(Url);
      // }

      if (this.clientType == "android") {
        window.android.getInfo(112, Url);
      } else {
        //IOS
        console.log(Url);
        window.webkit.messageHandlers.getJumpUrl.postMessage(Url);
      }
    },
  },
};
</script>
<style lang="less">
.activityDetail {
  background: #f5f6f8;
  padding-top: 10px;
  .container {
    width: 100%;
    overflow: hidden;
    padding: 15px 0;
  }
  .partPage {
    margin-bottom: 10px;
    background: #fff;
    padding: 0 15px;
  }
  .title {
    color: #000000;
    font-size: 16px;
    line-height: 50px;
    border-bottom: 1px solid #f5f6f8;
  }
  .netNum {
    color: #000;
    font-size: 20px;
    padding: 5px 0;
  }
  .netTitle {
    font-size: 14px;
  }
  .smallTitle{
    font-size: 12px;
  }
  .num {
    font-size: 14px;
    color: #000;
    padding-top: 3px;
  }
  .income {
    width: 100%;
    flex-shrink: 0;
    padding-right: 10px;
    position: relative;
    .arrowRight {
      position: absolute;
      right: 5px;
      top: 15px;
    }
  }
  .incomeWrap {
    align-items: flex-end;
    padding: 10px 0;
  }
  .rateWrap {
    // width: 100%;
    padding-left: 30px;
    .rate {
      background: #c2d5fa;
      height: 14px;
    }
  }
}
</style>
